var _style, _circle, _path, _circle2, _path2, _circle3, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommittees = function SvgCommittees(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "committees_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".committees_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12.8,
    r: 1.8,
    className: "committees_svg__st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1 17.1c-1-1.7-3.2-2.3-4.9-1.4C1.4 16.2.7 17 .5 18",
    className: "committees_svg__st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12.8,
    r: 1.8,
    className: "committees_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 17.1c1-1.7 3.2-2.3 4.9-1.4.9.5 1.5 1.3 1.7 2.2",
    className: "committees_svg__st0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3.2,
    r: 1.8,
    className: "committees_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.5C15 6.6 13 5.4 11.1 5.9c-1.3.3-2.3 1.3-2.6 2.6M17.7 21.3c.1.5-.2 1.1-.8 1.2H7.2c-.6 0-1-.4-1-1v-.2l2.1-10c.1-.5.5-.8 1-.8h5.4c.5 0 .9.3 1 .8z",
    className: "committees_svg__st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 19.9c0 .3-.2.5-.4.6h-3.9c-.3 0-.5-.2-.5-.5v-.1l.4-2.5c0-.2.2-.4.5-.4h3.1c.2 0 .5.2.5.4z",
    className: "committees_svg__st0"
  })));
};
export default SvgCommittees;